import React, {ReactNode, useState} from 'react';
import {ModelTreeNode} from '../../../../../../store/modelFile';
import FileManagerAntd, {FileManagerAntdHooks} from './FileManagerAntd';
import {getModelEditFilesMode, ModelEditFilesMode} from './utils';
import {ModelDTO} from 'hemwb-api';
//import {isModelTheorem, isModelExternal} from '../../../../../../store/model';

export type ModelEditFilesAntdProps = {
  model: ModelDTO;
  files?: ModelTreeNode[];
  onChange?: (updatedModel: ModelDTO, updatedFiles: ModelTreeNode[]) => void;
  onSubmit: (updatedModel: ModelDTO, updatedFiles: ModelTreeNode[]) => void;
  buttons: () => string | ReactNode;
  createFlow?: boolean;
  uploadFlow?: boolean;
  unSelectAll?: boolean;
  customUploadArea?: (hooks: FileManagerAntdHooks) => ReactNode;
};

const ModelEditFilesAntd: React.FC<ModelEditFilesAntdProps> = ({
  model,
  files,
  unSelectAll,
  customUploadArea,
  ...restProps
}) => {
  //const [workingModel, setWorkingModel] = useState<ModelDTO>({...model, metadata: {...model.metadata}});
  const [forcedMode, setForcedMode] = useState<ModelEditFilesMode>();
  const mode = forcedMode || getModelEditFilesMode(model, files);
  //const externalModel = isModelExternal(model);
  //const theoremModel = isModelTheorem(model);
  return (
    <>
      <FileManagerAntd
        model={model}
        files={files}
        onEdit={() => mode === ModelEditFilesMode.NONE && setForcedMode(ModelEditFilesMode.MLMP)}
        mode={mode}
        customUploadArea={customUploadArea}
        {...restProps}
      />
    </>
  );
};

export default ModelEditFilesAntd;
